import React from "react";
import "./styles.css";
import logo from "../../assets/icons/muscleup.svg";

const Header = () => {
  return (
    <header className="header-container">
      <div className="header-subcontainer">
        <img className="header-logo" src={logo} alt="Muscle Up logo" />

        <div className="header-text">
          <span className="header-text-muscle">Muscle</span>
          <span className="header-text-up">Up</span>
          <span className="helper-text"> — Workout Tracker & Gym Log</span>
        </div>
      </div>
    </header>
  );
};

export default Header;
